import { render, staticRenderFns } from "./powerConfig.vue?vue&type=template&id=7a4dd041&"
import script from "./powerConfig.vue?vue&type=script&lang=js&"
export * from "./powerConfig.vue?vue&type=script&lang=js&"
import style0 from "./powerConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "powerConfig.vue"
export default component.exports